import { Stack } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../../../hooks';
import { getGenerationId } from '../../../../store/GenerationSlice';
import { AppDispatch, RootState } from '../../../../store/store';
import { Mode } from '../../../../types/common';
import { BaseForm, FormInput } from '../../../UI';

const INIT_INPUT = {
  title: '',
};

const VALIDATE_FIELDS = ['title'];

const RutubeForm: React.FC = () => {
  const { input, error, handleChange, submit, resetForm, tags, handleAddTag, handleDeleteTag, handlePressKey } =
    useForm(INIT_INPUT, handleSubmit, VALIDATE_FIELDS);
  const { isGenerationLoading, isHistoryLoading } = useSelector((state: RootState) => state.generation);
  const dispatch = useDispatch<AppDispatch>();

  function handleSubmit() {
    dispatch(getGenerationId({ ...input, tags, mode: Mode.Rutube }));
  }

  return (
    <BaseForm onSubmit={submit} onReset={resetForm}>
      <Stack gap={'20px'}>
        <FormInput
          onChange={handleChange}
          error={error?.title || ''}
          name={'title'}
          value={input.title || ''}
          placeholder={'Легкий рецепт куриных котлеток за 30 минут'}
          label={'Название видео'}
          maxLength={350}
          required
        />

        <FormInput
          onChange={handleChange}
          onAddTag={handleAddTag}
          onDeleteTag={handleDeleteTag}
          onKeyPress={handlePressKey}
          name={'tags'}
          value={input.tags || ''}
          placeholder={'Например, простые рецепты'}
          label={'Ключевые слова'}
          tags={tags}
          disabled={isGenerationLoading || isHistoryLoading}
          maxLength={30}
        />
      </Stack>
    </BaseForm>
  );
};

export default RutubeForm;
